import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';

@observer(["CustomWagerStore"])
class StepTwo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstOutcome: "I will guess your birthday",
            secondOutcome: "No you won't",

        };
        this.handleChangeSecondOutcome = this.handleChangeSecondOutcome.bind(this);
        this.handleChangeFirstOutcome = this.handleChangeFirstOutcome.bind(this);
    }
    componentWillMount() {
        const { CustomWagerStore } = this.props;

        CustomWagerStore.setOutcomeOne(this.state.firstOutcome);
        CustomWagerStore.setOutcomeTwo(this.state.secondOutcome);
    }
    handleChangeFirstOutcome(e) {
        const { CustomWagerStore } = this.props;

        CustomWagerStore.setOutcomeOne(e.target.value);
        this.setState({ firstOutcome: e.target.value })
        console.log(CustomWagerStore.newCustomWager.outcomeOne);
    }

    handleChangeSecondOutcome(e) {
        const { CustomWagerStore } = this.props;

        CustomWagerStore.setOutcomeTwo(e.target.value);
        this.setState({ secondOutcome: e.target.value })
        console.log(CustomWagerStore.newCustomWager.outcomeTwo);
    }

    render() {

        return (
            <div>
                <h1>Select Your Bet's Outcomes</h1>
                <div className="custom-bets-form">
                    <div className="custom-bets-form-grid-no-margin">
                        <div className="custom-bets-form-grid-section">
                            <div className="custom-bets-form-field">
                                <div className="custom-bets-form-field-title" style={{ color: '#3ac55a' }}>Enter the outcome you're betting on: </div>
                                <input
                                    type="text"
                                    className="custom-input-success"
                                    value={this.state.firstOutcome}
                                    onChange={this.handleChangeFirstOutcome}
                                />
                            </div>
                        </div>
                        <div className="custom-bets-form-grid-section">
                            <div className="custom-bets-form-field">
                                <div className="custom-bets-form-field-title" style={{ color: '#ff4d4f' }}>Enter the outcome your opponent is betting on: </div>
                                <input
                                    type="text"
                                    className="custom-input-danger"
                                    value={this.state.secondOutcome}
                                    onChange={this.handleChangeSecondOutcome}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="custom-bets-outcome-wrap">
                        <div className="custom-bets-outcome-grid">
                            <div className="custom-bets-outcome-grid-item">
                                <div className="custom-bets-outcome-grid-item-you-box">
                                    <div className="custom-bets-outcome-grid-item-you-box-title">
                                        YOU
                                    </div>
                                    <div className="custom-bets-outcome-grid-item-you-box-outcome">
                                        {this.state.firstOutcome}
                                    </div>
                                </div>
                            </div>
                            <div className="custom-bets-outcome-grid-item">
                                <div className="custom-bets-outcome-grid-item-opponent-box">
                                    <div className="custom-bets-outcome-grid-item-opponent-box-title">
                                        OPPONENT
                                    </div>
                                    <div className="custom-bets-outcome-grid-item-opponent-box-outcome">
                                        {this.state.secondOutcome}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StepTwo;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/customBetSteps/StepTwo.js